import styled, { css } from "styled-components";
import { BorderColors } from "@abel-technologies-as/components";

const ModalBody = styled.div``;

const Divider = styled.div`
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const fieldContainerStyle = css`
	border-top-left-radius: 0px;
	border-bottom-left-radius: 0px;
	border-left: 0px;
`;

const buttonStyle = css`
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
`;

const HttpBox = styled.div<{ hasError?: boolean }>`
	border-top-right-radius: 0px;
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
	padding: 12px 10px;
	margin-bottom: 16px;
	border: 1px solid ${({ hasError }) => (hasError ? "rgb(253, 162, 155)" : BorderColors.Primary)};
	border-bottom-right-radius: 0px;
`;

export { ModalBody, Divider, fieldContainerStyle, buttonStyle, HttpBox };
